﻿import { connect } from 'react-redux'

//state
import { stopAction } from '../../State/actions'

// components
import QuestionHeader from './QuestionHeader';

// utils
import * as constants from '../../Utils/constants';


const StopDialog = ( props ) => {

    const onCancel = () => {
        props.stop(false)
    }

    const onRedirect = () => {
        window.location.href = `${constants.redirects.advise}`;
    }

    return (
        <div className="pension-wizard-block__question__card">
            <QuestionHeader
                total=""
                index=""
                headline={props.headline}
                text={props.text}
            />
            <button
                className="button button--green"
                onClick={onRedirect}>
                {constants.stopDialog.buttonText}
            </button>

            <a
                className="pension-wizard-block__question__card__link"
                onClick={onCancel}>
                {constants.stopDialog.linkText}
            </a>
        </div>
     )
}

const mapStateToProps = (state) => {
    return {
        content: state.pensionWizardModal.modalContent
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        stop: (payload) => dispatch(stopAction(payload)),
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(StopDialog);

